<template>
    <div>
        <header class="w-full h-14 bg-blue-900 text-white ">
            <div class="h-full max-w-md px-4 mx-auto flex items-center justify-between">
                <h1 class="font-semibold text-lg">Lån af udendørsarealer</h1>
                <img
                    class="w-10"
                    src="./assets/AAK_mønt_RGB_hvid.svg"
                    alt="Aalborg Kommune Logo"
                />
            </div>
        </header>
        <nav class="mx-auto text-sm  h-10 bg-gray-100">
            <div class=" max-w-md mx-auto h-full flex items-center justify-center">
                <router-link  to="/ny">Ny reservation</router-link>
                <router-link to="/liste">Arealer</router-link>
            </div>
        </nav>
        <router-view></router-view>
        <div class=" max-w-md mx-auto">
            <img class="w-40 mx-auto my-4" src="./assets/AAK_logo_RGB_Blå.svg" alt="Aalborg Kommune Logo">
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    created() {
        this.$route.path == "/" ? this.$router.replace('/ny') : false
    }
}
</script>

<style scoped >
nav a {
    @apply text-center w-full h-full flex items-center justify-center text-gray-700
}
.router-link-active{
    @apply bg-white font-semibold
}
</style>

